import React, { FC, useMemo } from 'react';
import styled, { css } from 'styled-components/macro';
import ReactPerfectScrollbar from 'react-perfect-scrollbar';
import { List } from '@mui/material';
import navItems, { navSuperAdminItems } from './navMenuItems';
import SidebarNavSection from './SidebarNavSection';

import '../../assets/vendor/perfect-scrollbar.css';
import { useAuth } from '../../context/auth-context';
import { UserRole } from '../../types/user.types';

const baseScrollbar = css`
  background-color: #0f172a;
  border-right: 1px solid rgba(148, 163, 184, 0.12);
`;

const PerfectScrollbar = styled(ReactPerfectScrollbar)`
  ${baseScrollbar}
`;

const Items = styled.div<{ $collapsed: boolean }>`
  padding: ${(props) => (props.$collapsed ? '4px 14px' : '3px 5px')};
`;

const SidebarNav: FC<{ collapsed?: boolean }> = ({ collapsed = false }) => {
  const { currentUser } = useAuth();
  const menu = useMemo(() => {
    if (currentUser?.role !== UserRole.superAdmin) {
      return navItems;
    }

    const superAdminPages = navSuperAdminItems.flatMap(
      (section) => section.pages,
    );

    return navItems.map((section) =>
      section.title === 'Settings'
        ? { ...section, pages: [...section.pages, ...superAdminPages] }
        : section,
    );
  }, [currentUser?.role]);

  return (
    <PerfectScrollbar>
      <List disablePadding>
        <Items $collapsed={collapsed}>
          {menu.map((item, index) => (
            <SidebarNavSection
              key={item.title}
              pages={item.pages}
              title={item.title}
              collapsed={collapsed}
              isFirst={index === 0}
            />
          ))}
        </Items>
      </List>
    </PerfectScrollbar>
  );
};

export default SidebarNav;
